var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isRepost)?_c('trust',{attrs:{"trust":_vm.post.trust.trust ? _vm.post.trust.trust : 0,"post":_vm.post},on:{"setTrust":_vm.setTrust}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }